/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TravelControllerDeleteImage$Params {
  id: number;
  media_id: number;
}

export function travelControllerDeleteImage(http: HttpClient, rootUrl: string, params: TravelControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, travelControllerDeleteImage.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('media_id', params.media_id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

travelControllerDeleteImage.PATH = '/travel/{id}/picture/{media_id}';
